import { LoginType } from "game-interface";

const Config = {
  MainnetUnsupportedChain: [LoginType.Terra],
  // @ts-ignore
  Host: window.getHost(),
};
export default Config;
